import React, { useEffect, useState } from "react";
import { MailCheck, MailWarning } from "lucide-react";
import api from "../../lib/api";

export default function EmailStatusBanner() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/admin/email-status").then((r) => setS(r.data)).catch(() => {}); }, []);
  if (!s) return null;

  const ok = s.enabled && s.domain_verified;
  const last = s.last ? new Date(s.last.timestamp).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" }) : "no alerts sent yet";

  return (
    <div data-testid="email-status-banner" className={`border rounded-md p-4 flex items-start gap-3 font-body text-xs ${ok ? "bg-emerald-50 border-emerald-200 text-emerald-800" : "bg-[#F5D5B0]/40 border-[#C8956A] text-[#6B1414]"}`}>
      {ok ? <MailCheck size={18} className="shrink-0 mt-0.5" /> : <MailWarning size={18} className="shrink-0 mt-0.5" />}
      <div className="space-y-1">
        <p className="font-bold">
          {!s.enabled ? "Lead email alerts are OFF (no Resend key)." : ok ? `Lead alerts live from ${s.configured_sender} → ${s.recipient}${s.cc?.length ? ` (cc ${s.cc.join(", ")})` : ""}` : `Lead alerts live → ${s.recipient}, sending from Resend's test address until calium.in is verified.`}
        </p>
        <p className="opacity-80">
          Last alert: {last}{s.last?.status === "failed" ? ` · FAILED: ${s.last.error}` : ""}
          {!ok && s.enabled && <> · Add the DNS records at GoDaddy, click Verify at <a href="https://resend.com/domains" target="_blank" rel="noreferrer" className="underline">resend.com/domains</a>; the switch to alerts@calium.in is automatic.</>}
        </p>
      </div>
    </div>
  );
}
